// extracted by mini-css-extract-plugin
export default {"priorityMgr":"Priority__priorityMgr___ZoHfG","priorityIcon":"Priority__priorityIcon___oaWL5","popoverOverlay":"Priority__popoverOverlay___qpPUT"};